import axios from 'axios';
import qs from 'qs';
import { IUserUpsert } from '../../@types/modelV2/rights/user/userUpsert';
import { ISqlEmployee } from '../../@types/modelV2/rights/user/sqlEmployee';
import { IGoogleLogInModel } from '../../@types/modelV2/auth/logIn/GoogleLogInModel';

export default class UserHttpService {
    
    public static getUserByUid = async (uid : string) : Promise<ISqlEmployee> => {
        const result = await axios.get(`${API_URL}/v1/User/GetByUid`, {
            params: {
                uid
            },
        });

        return result.data;
    }

    public static getUsersList = async (isActive : boolean | null) : Promise<Array<ISqlEmployee>> => {
        const result = await axios.get(`${API_URL}/v1/User/GetList`, {
            params: {
                isActive
            },
            paramsSerializer: qs.stringify
        });

        return result.data;
    }

    public static userUpsert = async (upsert : IUserUpsert) : Promise<ISqlEmployee> => {
        const result = await axios.post(`${API_URL}/v1/User/Edit`, upsert);
        return result.data; 
    }

    public static linkGoogleAccount = async (googleLoginModel : IGoogleLogInModel) : Promise<ISqlEmployee> => {
        const result = await axios.post(`${API_URL}/v1/User/LinkGoogleAccountToUser`, googleLoginModel);
        return result.data;
    }

    public static unlinkGoogleAccount = async () : Promise<ISqlEmployee> => {
        const result = await axios.post(`${API_URL}/v1/User/UnlinkGoogleAccountFromUser`, null);
        return result.data;
    }

    public static logoutUsers = async (userIds : Array<number>) : Promise<void> => {
        await axios.post(`${API_URL}/v1/User/LogoutUsers`, userIds);
    }

    public static userDelete = async (userId : number) : Promise<void> => {
        await axios.delete(`${API_URL}/v1/User/Delete`, {
            params: { userId },
        });
    }
}
